import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectUser } from '../../../../../store/user/user.selector';
import { importGroupCode } from '../../../../../utils/groups/importGroupCode';
import { HeaderCodeForm, HeaderCodeField, HeaderCodeInput, HeaderCodeSubmit } from './HeaderGroupCodeField.styles';

export default function HeaderGroupCodeField() {
  const dispatch = useDispatch();
  const user = useSelector(selectUser);
  const [code, setCode] = useState('');
  const [isAdding, setIsAdding] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!user?.uid || !code.trim() || isAdding) return;

    setIsAdding(true);
    try {
      await dispatch(importGroupCode(user.uid, code));
      setCode('');
    } finally {
      setIsAdding(false);
    }
  };

  if (!user?.uid) return null;

  return (
    <HeaderCodeForm onSubmit={handleSubmit}>
      <HeaderCodeField>
        <HeaderCodeInput
          type="text"
          value={code}
          onChange={(event) => setCode(event.target.value)}
          placeholder="Enter code..."
          aria-label="Add cards from a code"
          autoComplete="off"
          spellCheck={false}
          disabled={isAdding}
        />
        <HeaderCodeSubmit type="submit" disabled={!code.trim() || isAdding}>
          {isAdding ? '…' : 'ADD'}
        </HeaderCodeSubmit>
      </HeaderCodeField>
    </HeaderCodeForm>
  );
}
